export const quickUpdateImport = () => import("@/pages/QuickUpdate");

export const prefetchQuickUpdate = () => {
  quickUpdateImport().catch(() => {});
};